export interface GetCustomerSubscriptionResponse {
    customerSubscription: CustomerSubscriptionModel;
}

export interface CustomerSubscriptionModel {
    customerId: number;
    productId?: number;
    productCode: string;
    subscriptionTypeId: number;
    maxVesselsCount: number;
    maxVesselChangesCount: number;
    currentVesselChangesCount: number;
    currentVesselsCount: number;
    maxCompaniesCount: number;
    maxCompanyChangesCount: number;
    currentCompanyChangesCount: number;
    currentCompaniesCount: number;
    includeCompanyData: boolean;
    startDate? : Date;
    isExpired: boolean;
    trialLength? : number;
    subscriptionLength? : number;
    trialEndDate? : Date;
    subscriptionEndDate: Date
    customerSubscriptionId?: number;
    status: string;
}

export interface CreateOrderRequest {
    webOrderNumber?: string;
    customerNumber: string;
    userName: string;
    balance?: number;
    orderLines: OrderLineRequestModel[];
    paymentMethod?: number;
}

export interface OrderLineRequestModel {
    productNumber: string;
    quantity?: number;
    status: number;
    queryParams?: string;
    productPrice?: number;
    totalPrice?: number;
    discounts?: DiscountModel[];
}

export interface DiscountModel {
    reason: string;
    promotionCode: number;
    discount: number;
}

// Keep the name as Upper Case since RightStore API return with DefaultNamingStrategy
export interface CreateOrderResponsse {
    orderLines: OrderLineResponseModel[];
}

export interface OrderLineResponseModel {
    productNumber: string;
    url: string;
    quantity: number;
    totalPrice: number;
}

export interface GetCustomerSubscriptionVesselsResponse {
    vessels: CustomerSubscriptionVesselModel[];
}

export interface CustomerSubscriptionVesselModel {
    vesselId: number;
    addedDate: Date;
}

export enum SubscriptionTypeEnum {
    LimitedSubscription = 1,
    FullSubscription = 2
}

export enum OrderLineStatusEnum {
    Initial = 1,
    Canceled = 4
}

export interface RightStoreCheckoutModel {
    customerNumber: number;
    productNumber: string;
    standardDescription: string;
    canOverridePriceInAppPurchase: boolean;
    userName: string;
    queryParams: string;
    quantity: number;
    creditBalance: number;
    canCustomerInvoice: boolean;
    preventRedirect: boolean;
    afterPurchase: (url:string, priority:boolean) => Promise<void>;
    processStandardProduct: () => Promise<string>;
}

export interface RightStoreCheckoutProductInformationModel {
    productNumber: string;
    productName: string;
    productDescription: string;
    productImage: string;
    productUrl: string;
    totalPrice: number;
    lastPurchasedOn: Date;
    previousPurchaseStillValid: boolean;
    canChangeQuantity: boolean;
    isQuoteRequired: boolean;
    availablePaymentMethods: number[];
    customerBalance: number;
}

export interface RightStoreCheckoutPurchaseModel {
    productNumber: string;
    customerNumber: number;
    userName: string;
    queryParams: string;
    checkoutQuantity: number;
    paymentMethod?: number;
}

export interface PurchaseProductResponse {
    status: boolean;
    webOrderNumber: string;
    fullfillmentUrl: string;
}

export interface BudgetClientModel {
    budgetId: number;
    businessUnitId: number;
    paidCredits: number;
    bonusCredits: number;
    activationDate: Date;
    expirationDate: Date;
    usedCredits: number;
    expiredCredits: number;
    remainingCredits: number;
}

export enum PaymentTypeEnum {
    RightStoreCredits = 1,
    Invoice = 2,
    CreditCards = 3
}

export interface ProductVariant {
    productName: string;
    productDescription: string;
    isFree: boolean;
}

export const SubscriptionProductCodes = {
    informationServices: 'information-services'
}